import { Injectable } from '@angular/core';

import {take} from "rxjs/operators";
import {Observable} from "rxjs";

import { VersionService } from '../services/version/version.service';

@Injectable({ providedIn: 'root' })
export default class VersionFacade {
  constructor(private readonly _service: VersionService) {}

  public checkIfVersionsAreDifferent(): Observable<boolean> {
    return this._service.checkIfVersionsAreDifferent();
  }

  public processCheckIfVersionsAreDifferent(different: boolean): void {
    this._service.processCheckIfVersionsAreDifferent(different);
  }

  public detectChanges(): void {
    this.checkIfVersionsAreDifferent()
      .pipe(take(1))
      .subscribe(status => this.processCheckIfVersionsAreDifferent(status));
  }
}
